import { EProcessID, EProcessType, EProgressStatus, EEntityStatus } from '../../enums'
import { IRoutePath } from '..'

export enum EBindingSetting {
  LINKAGE_GOODS_LINE_BINDING = 'linkageGoodsLineBinding',
  LINKAGE_GOODS_LINE_PACKING_BINDING = 'linkageGoodsLinePackingBinding',
  LINKAGE_GOODS_LINE_PRICE_BINDING = 'linkageGoodsLinePriceBinding',
  BINDINGS = 'bindings'
}

export interface ITWSendActivateProcess {
  [EBindingSetting.LINKAGE_GOODS_LINE_BINDING]: IRoutePath[]
  [EBindingSetting.LINKAGE_GOODS_LINE_PACKING_BINDING]: IRoutePath[]
  [EBindingSetting.LINKAGE_GOODS_LINE_PRICE_BINDING]: IRoutePath[]
  [EBindingSetting.BINDINGS]: IRoutePath[]
}

export interface ITWProcess {
  entityId: string
  tradingName: string
  processId: EProcessID
  processName: string
  processType: EProcessType
  processProgressStatusCd: EProgressStatus
  entityProgressStatusCd: EEntityStatus
  processSeq: number
}
